const filterContent = {
  DIRECT_DEBIT: "پس‌انداز خودکار",
  CHARGE: "شارژ مستقیم",
  BONUS: "جایزه",
  REFUND_WAGE: "کارمزد برگشتی سامانه",
  GIFT: "هدیه",
  REFUND: "برگشتی",
  PENDING: "درانتظار تائید",
  CANCEL: "ناموفق",
  DONE: "موفق",
  AUTO_PURCHASE: "سرمایه‌گذاری خودکار",
  PURCHASE: "سرمایه‌گذاری مستقیم",
  CASHOUT: "برداشت از قلک",
  all: "همه",
  allDate: "از ابتدا تا اکنون",
  lastDay: "روز جاری",
  lastWeek: "هفته‌ی جاری",
  lastMonth: "ماه جاری",
  lastYear: "سال جاری",
};
export default filterContent;
